// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-company-about-index-wrapper-buofp{display:grid;grid-gap:24px}.pages-company-about-index-pageWrapper-bnzzf{padding-bottom:48px}.pages-company-about-index-pageWrapper-bnzzf.pages-company-about-index-mobile-mlwtu{padding-top:48px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "pages-company-about-index-wrapper-buofp",
	"pageWrapper": "pages-company-about-index-pageWrapper-bnzzf",
	"mobile": "pages-company-about-index-mobile-mlwtu"
};
module.exports = ___CSS_LOADER_EXPORT___;
